import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1740,0 C1839.24,0 1920,80.76 1920,180 L1920,180 L1920,1740 C1920,1839.24 1839.24,1920 1740,1920 L1740,1920 L180,1920 C80.76,1920 0,1839.24 0,1740 L0,1740 L0,180 C0,80.76 80.76,0 180,0 L180,0 Z M1800,720 L720,720 L720,1800 L1665,1800 C1739.25,1800 1800,1739.25 1800,1665 L1800,1665 L1800,720 Z M600,1320 L120,1320 L120,1740 C120,1773 147,1800 180,1800 L180,1800 L600,1800 L600,1320 Z M600,720 L120,720 L120,1200 L600,1200 L600,720 Z M1740,120 L1320,120 L1320,600 L1800,600 L1800,180 C1800,147 1773,120 1740,120 L1740,120 Z M1200,120 L720,120 L720,600 L1200,600 L1200,120 Z M600,120 L180,120 C147,120 120,147 120,180 L120,180 L120,600 L600,600 L600,120 Z M1734,961.558504 L1564.4415,792 L1259.5,1096.9415 L954.558504,792 L785,961.558504 L1089.9415,1266.5 L785,1571.4415 L954.558504,1741 L1259.5,1436.0585 L1564.4415,1741 L1734,1571.4415 L1429.0585,1266.5 L1734,961.558504 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTableSplitCellsLine = /*#__PURE__*/function (_Component) {
  _inherits(IconTableSplitCellsLine, _Component);

  var _super = _createSuper(IconTableSplitCellsLine);

  function IconTableSplitCellsLine() {
    _classCallCheck(this, IconTableSplitCellsLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconTableSplitCellsLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTableSplitCells",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTableSplitCellsLine.displayName = "IconTableSplitCellsLine";
  return IconTableSplitCellsLine;
}(Component);

IconTableSplitCellsLine.glyphName = 'table-split-cells';
IconTableSplitCellsLine.variant = 'Line';
IconTableSplitCellsLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTableSplitCellsLine;
export { IconTableSplitCellsLine };